import React from 'react';

/**
 * ErrorBoundary - Catches React rendering errors and shows a fallback UI
 * Prevents black screen on Android WebViews (Instagram, Facebook, etc.)
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#0a0a1a',
          color: '#d4af37',
          padding: '2rem',
          textAlign: 'center',
          fontFamily: 'Georgia, serif'
        }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>DiscreetLux</h1>
          <p style={{ color: '#9ca3af', marginBottom: '1.5rem', maxWidth: '400px' }}>
            Une erreur est survenue. Veuillez ouvrir ce lien directement dans votre navigateur (Chrome, Safari) pour une meilleure expérience.
          </p>
          <button 
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            style={{
              padding: '0.75rem 2rem',
              backgroundColor: '#d4af37',
              color: '#0a0a1a',
              border: 'none',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: 'bold'
            }}
          >
            Recharger la page
          </button>
          <a 
            href={window.location.href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              marginTop: '1rem',
              color: '#d4af37',
              textDecoration: 'underline',
              fontSize: '0.85rem'
            }}
          >
            Ouvrir dans le navigateur
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
